module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('section', {
    staticClass: "data-cont mould-index"
  }, [_c('h3', {
    staticClass: "fx fx-x-between fx-y-center count-title"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "placeholder": "选择日期范围(默认全部)",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": _vm.handleGetStatisticsCount
    },
    model: {
      value: (_vm.stasticDate),
      callback: function($$v) {
        _vm.stasticDate = $$v
      },
      expression: "stasticDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "count-wapper"
  }, [_c('div', {
    staticClass: "all-count member-cont"
  }, [_c('div', {
    staticClass: "member-data"
  }, [_c('ul', {
    staticClass: "fx text-center"
  }, [_c('li', {
    staticClass: "fx-fill"
  }, [_c('strong', [_vm._v(_vm._s(_vm.count.sytNum + _vm.count.vmallNum))]), _vm._v(" "), _c('p', [_vm._v("交易总笔数（单位/笔）")])]), _vm._v(" "), _c('li', {
    staticClass: "fx-fill"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("filterMoney")((_vm.count.sytMoney + _vm.count.vmallMoney))))]), _vm._v(" "), _c('p', [_vm._v("交易总金额（单位/元）")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-t-20 p-b-20"
  }, [_c('ul', {
    staticClass: "fx fx-wrap"
  }, [_c('li', [_c('dl', {
    staticClass: "text-center"
  }, [_c('dt', [_vm._v("收银台")]), _vm._v(" "), _c('dd', [_vm._v("交易笔数（笔）："), _c('i', [_vm._v(_vm._s(_vm.count.sytNum))])]), _vm._v(" "), _c('dd', [_vm._v("交易金额（元）："), _c('i', [_vm._v(_vm._s(_vm._f("filterMoney")(_vm.count.sytMoney)))])]), _vm._v(" "), _c('dd', [_c('router-link', {
    attrs: {
      "to": {
        name: 'payCount'
      }
    }
  }, [_vm._v("查看详情 >>")])], 1)])]), _vm._v(" "), _c('li', [_c('dl', {
    staticClass: "text-center"
  }, [_c('dt', [_vm._v("微商城")]), _vm._v(" "), _c('dd', [_vm._v("交易笔数（笔）："), _c('i', [_vm._v(_vm._s(_vm.count.vmallNum))])]), _vm._v(" "), _c('dd', [_vm._v("交易金额（元）："), _c('i', [_vm._v(_vm._s(_vm._f("filterMoney")(_vm.count.vmallMoney)))])]), _vm._v(" "), _c('dd', [_c('router-link', {
    attrs: {
      "to": {
        name: 'statistics'
      }
    }
  }, [_vm._v("查看详情 >>")])], 1)])]), _vm._v(" "), _c('li', [_c('dl', {
    staticClass: "text-center"
  }, [_c('dt', [_vm._v("公众号粉丝")]), _vm._v(" "), _c('dd', [_vm._v("关注粉丝数（个）："), _c('i', [_vm._v(_vm._s(_vm.count.subMemberCount))])]), _vm._v(" "), _c('dd', [_vm._v("取消粉丝数（个）："), _c('i', [_vm._v(_vm._s(_vm.count.cancelMemberCount))])]), _vm._v(" "), _c('dd', [_c('router-link', {
    attrs: {
      "to": {
        name: 'wxMember'
      }
    }
  }, [_vm._v("查看详情 >>")])], 1)])]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('section', {
    staticClass: "data-cont mould-index m-t-20"
  }, [_c('h3', {
    staticClass: "fx fx-x-between fx-y-center"
  }, [_vm._m(2), _vm._v(" "), _c('z-daybar', {
    attrs: {
      "on-click": _vm.handleGetStatisticsTrend
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-t-20",
    staticStyle: {
      "width": "auto",
      "height": "400px"
    },
    attrs: {
      "id": "trendData"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fx"
  }, [_c('p', [_vm._v("数据统计")]), _vm._v(" "), _c('div', {
    staticClass: "question-cont"
  }, [_c('i', {
    staticClass: "icon-question "
  }), _vm._v(" "), _c('div', {
    staticClass: "question-explain"
  }, [_c('h5', [_vm._v("交易总笔数")]), _vm._v(" "), _c('p', [_vm._v("所有交易的订单笔数(收银台+微商城)")]), _vm._v(" "), _c('h5', [_vm._v("交易总金额")]), _vm._v(" "), _c('p', [_vm._v("所有交易的总金额(收银台+微商城)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('dl', {
    staticClass: "text-center"
  }, [_c('dt', [_vm._v("会员卡")]), _vm._v(" "), _c('dd', [_vm._v("领卡人数（张）："), _c('i', [_vm._v("0")])]), _vm._v(" "), _c('dd', [_vm._v("消费次数（次）："), _c('i', [_vm._v("0")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fx fx-y-center"
  }, [_c('div', {
    staticClass: "fx"
  }, [_c('p', [_vm._v("交易趋势")]), _vm._v(" "), _c('div', {
    staticClass: "question-cont"
  }, [_c('i', {
    staticClass: "icon-question "
  }), _vm._v(" "), _c('div', {
    staticClass: "question-explain"
  }, [_c('h5', [_vm._v("交易金额")]), _vm._v(" "), _c('p', [_vm._v("交易金额趋势图分析(收银台+微商城)")]), _vm._v(" "), _c('h5', [_vm._v("交易笔数")]), _vm._v(" "), _c('p', [_vm._v("交易笔数趋势图分析(收银台+微商城)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4fb56188","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/index/Index.vue
// module id = 843
// module chunks = 0